'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _DollarCircleOutlined = _interopRequireDefault(require('./lib/icons/DollarCircleOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _DollarCircleOutlined;
  exports.default = _default;
  module.exports = _default;